<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">系统管理</li>
      </ul>
    </div>-->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 用户组管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <!-- <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl"></searchForm> -->
          <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
            <el-form-item label="用户组名称">
              <el-input placeholder="请输入用户组名称" v-model="seefrom.name"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/group/findAll"
            :parent="self"
            :config="config"
            :other="other"
            ref="usergroup"
          >
            <template slot="last">
              <el-table-column label="操作" width="500" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="edit(scope.$index, scope.row)"
                  >编辑</el-link>
                  <!-- <el-link icon="iconfont iconadd" type="text" size="small">添加</el-link> -->
                  <!-- <el-link
                    icon="iconfont iconsite"
                    type="text"
                    size="small"
                    @click="seeArea(scope.$index, scope.row)"
                  >查看区域详情</el-link> -->
                  <el-link
                    icon="iconfont iconuser"
                    type="text"
                    size="small"
                    @click="seeRole(scope.$index, scope.row)"
                  >查看角色详情</el-link>
                  <el-link
                    icon="iconfont iconadd"
                    type="text"
                    size="small"
                    @click="$router.push({name:'concatUser',params:{id:scope.row.id,groupName:scope.row.name}})"
                  >关联用户</el-link>
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="del(scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- <el-dialog class="editDialog" title="修改用户信息" :visible.sync="editDialogVisible">
          <searchForm :items="items"></searchForm>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="editDialogVisible = false">取消</el-button>
            <el-button class="confirmButton" type="primary" @click="editDialogVisible = false">确定</el-button>
          </div>
        </el-dialog>-->
        <el-dialog
          class="userGroupDialog"
          :visible.sync="displayFormEdit"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form ref="addEquipment" :model="addEquipment" :disabled="!seeBtn" :rules="rules">
            <el-form-item label="用户组名称" prop="name">
              <el-input placeholder="请输入工作组名称" v-model.trim="addEquipment.name"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="unit">
              <el-input placeholder="请输入备注" v-model="addEquipment.remark"></el-input>
            </el-form-item>

            <!-- <el-form-item label="地区选择" prop="area">
              <el-tree
                class="usergroup_area"
                :data="dataArea"
                show-checkbox
                node-key="id"
                :default-checked-keys="checkAreaIds"
                :filter-node-method="filterNode"
                ref="tree"
                highlight-current
                :props="areaProp"
              ></el-tree>
            </el-form-item> -->
            <el-form-item label="角色选择" prop="role">
              <el-select
                :popper-append-to-body="false"
                v-model="roleIds"
                multiple
                placeholder="请选择角色"
              >
                <el-option
                  v-for="item in dataRole"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="seeBtn">
            <el-button class="cancelButton" @click="displayFormEdit = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>

        <!-- <el-dialog class="userGroupDialog" :visible.sync="displayForm" width="70%" title="查看区域详情">
          <div class="table" style="width: 100%">
            <el-tree
              :data="dataArea"
              show-checkbox
              node-key="id"
              :default-expanded-keys="checkAreaIds"
              :default-checked-keys="checkAreaIds"
              :filter-node-method="filterNode"
              ref="tree"
              highlight-current
              :props="areaProp"
            ></el-tree>
          </div>
        </el-dialog> -->

        <el-dialog
          class="userGroupDialog"
          :visible.sync="displayFormRole"
          width="70%"
          title="查看角色详情"
        >
          <div class="table" style="width: 100%">
            <el-table class="stripeTable" :data="tableDataRole" border style="width: 100%">
              <el-table-column prop="name" label="角色名称" align="center" width="100"></el-table-column>
              <el-table-column prop="remark" label="备注" align="center" width="300"></el-table-column>
              <!-- <el-table-column prop="perms" label="角色标识" align="center" width="200"></el-table-column> -->
              <el-table-column prop="create_time" label="创建时间" align="center" width="200"></el-table-column>
              <el-table-column prop="modify_time" label="修改时间" align="center" width="200"></el-table-column>
            </el-table>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";
import { Loading } from "element-ui";

export default {
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入用户组名称", trigger: 'blur' }]
      },
      loading: true,
      title: "",
      tabName: "jsgl",
      form_jsgl: {},
      editDialogVisible: false,
      showTable: true,
      seeBtn: true,
      other: {},
      displayForm: false,
      displayFormEdit: false,
      displayFormRole: false,
      //组id关联地区和角色
      tableDataArea: [],
      tableDataRole: [],
      //所有区域角色供选择
      dataArea: [],
      dataRole: [],
      //组id已经关联的区域ids
      checkAreaIds: [],
      //输入框显示已选择角色
      roleIds: [],
      areaProp: {
        children: "areas",
        label: "name"
      },
      seefrom: {
        name: ""
      },
      addEquipment: {
        name: "",
        remark: "",
        create_time: ""
      }
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "用户组"
        },
        {
          prop: "remark",
          label: "备注"
        },
        {
          prop: "create_time",
          label: "创建时间"
        },
        {
          prop: "modify_time",
          label: "修改时间"
        }
        // {
        //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
        //   label: "随便"
        // }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
    //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.$refs.usergroup.pageToOne();
      this.$nextTick(this.$refs.usergroup.getData);
    },
    //重置
    reset() {
      this.seefrom.name = "";
    },
    //新增
    addnew() {
      this.title = "新增用户组";
      this.state = 1;
      this.displayForm = false;
      this.displayFormRole = false;
      this.displayFormEdit = true;
      this.seeBtn = true;
      this.addEquipment.name = "";
      this.addEquipment.remark = "";
      this.roleIds.length = 0;
      this.checkAreaIds.length = 0;
      //加载所有区域以及角色
      this.findAllAreaAndRole();
      this.$nextTick(() => {
          this.$refs["addEquipment"].clearValidate();
        })
    },
    //确认
    submitAdd() {
      let halfAreaId = [];
      let allareaId = [];
      this.$refs["addEquipment"].validate(valid => {
        if (valid) {
          // halfAreaId = this.$refs.tree.getHalfCheckedKeys();
          // //console.log(halfAreaId, "half");
          // allareaId = this.$refs.tree.getCheckedKeys();
          // let areaIds = allareaId.concat(halfAreaId);
          // //console.log(areaIds, "areaIds");
          if (this.state === 1) {
            this.$axiosput("operation/group/save", {
              name: this.addEquipment.name,
              remark: this.addEquipment.remark,
              // areaIds: areaIds,
              roleIds: this.roleIds
            }).then(res => {
              if (res.data.status === "10000") {
                this.displayFormEdit = false;
                this.subSeefrom();
                let loading = Loading.service({});
                loading.close();
                this.$message.success("添加成功！");
              } else {
                this.$message.danger("添加失败！");
              }
            });
          } else if (this.state === 2) {
            this.$axiospost("operation/group/update", {
              id: this.id,
              name: this.addEquipment.name,
              remark: this.addEquipment.remark,
              // areaIds: areaIds,
              roleIds: this.roleIds,
              create_time: this.addEquipment.create_time
            }).then(res => {
              if (res.data.status === "10000") {
                //关闭按钮
                this.displayFormEdit = false;
                //清空数据
                this.checkAreaIds.length = 0;
                this.subSeefrom();
                this.$message.success("修改成功！");
              } else {
                this.$message.danger("修改失败！");
              }
            });
          }
        }
      });
    },
    //编辑
    edit(index, row) {
      this.title = "编辑用户组";
      this.displayForm = false;
      this.displayFormRole = false;
      this.displayFormEdit = true;
      this.seeBtn = true;
      //清空角色ids
      this.roleIds.length = 0;
      //加载用户组数据
      this.$axiosget("operation/group/findById", {
        params: {
          id: row.id
        }
      }).then(res => {
        if (true) {
          this.addEquipment.name = row.name;
          this.addEquipment.remark = row.remark;
          this.state = 2;
          this.id = row.id;
          this.addEquipment.create_time = res.data.data.create_time;
        }
      });
      //加载所有区域，所有角色
      this.findAllAreaAndRole();
      //加载已选择地区id
      this.findAreasByGroupId(row.id); //将值赋值到tableDataArea属性
      //加载已经选中数据
      this.findRolesByGroupId(row.id);

      if (this.$refs["addEquipment"]) {
        this.$nextTick(() => {
          this.$refs["addEquipment"].clearValidate();
        })
      }
    },
    filterNode(value, data, node) {
      return value.some(id => id == data.id);
    },
    findAllAreaAndRole() {
    //   //加载所有地区数据
    //   this.dataArea.length = 0;
    //   this.$axiosget("operation/area/queryAll", {
    //     params: {
    //       ignoreCache: true
    //     }
    //   }).then(res => {
    //     if (true) {
    //       this.dataArea = res.data.data;
    //     }
    //   });
    //   this.$axiosget("operation/area/findAreaByUserId").then(res => {
    //     this.$nextTick(() => this.$refs.tree.filter(res.data.data));
    //   });
      // 加载所有角色数据
      this.dataRole.length = 0;
      this.$axiosget("operation/roleListAll").then(res => {
        //console.log(res);
        if (true) {
          this.dataRole = res.data.data;
        }
      });
    },
    seeArea(index, row) {
    //   this.displayForm = true;
    //   this.displayFormRole = false;
    //   this.displayFormEdit = false;
    //   this.findAreasByGroupId(row.id);
    //   this.findAllAreaAndRole();
    //   this.seeBtn = false;
    },

    seeRole(index, row) {
      this.displayFormEdit = false;
      this.displayForm = false;
      this.displayFormRole = true;
      this.findRolesByGroupId(row.id);
    },
    findRolesByGroupId(id) {
      this.$axiosget("operation/group/findRolesByGroupId", {
        params: {
          id: id
        }
      }).then(res => {
        if (true) {
          var roles = res.data.data;
          this.tableDataRole = roles;
          for (var i = 0; i < roles.length; i++) {
            this.roleIds.push(roles[i].id);
          }
        }
      });
    },
    findAreasByGroupId(id) {
      this.myData = [];
      this.$axiosget("operation/group/findAreasByGroupId", {
        params: {
          id: id
        }
      }).then(res => {
        if (true) {
          var arr = res.data.data; //后端数据（包括半选节点）
          //console.log(arr, "arr");
          // var g = [];
          // for (var j = 0; j < arr.length; j++) {
          //   g.push(arr[j].level);
          // }
          // var s = Math.min(...g);
          // for (var k = 0; k < arr.length; k++) {
          //   if (arr[k].level == s) {
          //     this.myData.push(arr[k]);
          //   }
          // }
          // this.tableDataArea = this.myData;
          //初始化areasIds
          this.checkAreaIds = []; //需要选中的节点
          let parArr = []; //获取父节点
          if (arr.length === 1) {
            this.checkAreaIds = [];
          } else {
            for (var i = 0; i < arr.length; i++) {
              parArr.push(arr[i].parentId);
            }
            //console.log(parArr, "parArr");
            for (var i = 0; i < arr.length; i++) {
              let id = arr[i].id;
              let isPar = parArr.includes(id);
              if (!isPar) {
                this.checkAreaIds.push(id);
              }
            }
          }

          //console.log(this.checkAreaIds, "checkAreaIds");
        }
      });
    },
    //删除
    del(row) {
      this.$confirm("删除该用户组?", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        //查询所有设备类型：开始
        this.$axiosdelete("operation/group/delete", {
          params: {
            id: row.id
          }
        }).then(res => {
          if (res.data.status === "2020") {
            this.$message.warning("该用户组有用户关联，无法删除！");
          } else {
            this.subSeefrom();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        }); //结束！
      }).catch(()=>{

      })
    }
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
.el-tree {
  background: rgba(0, 0, 0, 0.2);
  color: #b5b5b5;
}
// .el-tree-node__content:hover {
//   background-color: #2e3657 !important;
// }
// .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
//   background-color: #2e3657 !important;
// }

.userGroupDialog {
  .el-dialog {
    width: 586px;
  }
  .usergroup_area {
    width: 310px;
    margin-left: 0;
    border: 1px solid #3d4963;
    background: transparent;
    color: #cacaca;
  }
  // .el-select {
  //   margin-left: 48px;
  // }
  .stripeTable {
    width: 100%;
    background: transparent;
    border: 0 none;
  }
  .stripTable::after {
    width: 0;
    background: transparent;
  }

  .el-form-item {
    margin-top: 10px;
    margin-bottom: 0;
  }
  .el-form-item__label {
    color: #ccc;
    width: 138px;
    text-align: right;
  }
  .el-dialog__header {
    border-bottom: 1px solid #2d374d;
  }
  .el-dialog__body {
    padding-top: 45px;
  }
  .el-dialog__footer {
    padding-right: 116px;
    margin-top: 23px;
  }
  .el-dialog__title {
    border-bottom: 2px solid #35b9f7;
    font-size: 16px;
    display: inline-block;
    height: 52px;
    line-height: 52px;
    position: relative;
    top: -20px;
  }
  .el-input__inner {
    width: 310px;
    border: 1px solid #3d4963;
    border-radius: 0;
  }
  .el-input__inner:focus {
    border: 1px solid #3587c7;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/system/usergroup/index.vue